
<mat-dialog-content *ngIf="!isSmallDevice" class="mat-typography">
  <h2 class="einruecken" mat-dialog-title>{{ data.title | translate }}</h2>
  <form class="form-wrapper" [formGroup]="timeForm" autocomplete=off>

      <zeiterfassung-stufen class="stufenAnzeige"
                            [selectboxItems]="$projektSelectbox | async"
                            (verNiver)="nichtVerrechnenVerrechnen($event)"
                            [disablen]='disableProjektstufe'
      >
      </zeiterfassung-stufen>
    <div class="eineLinie">
      <mat-checkbox formControlName="tagestotal"
                  class="checkboxAbstand"
    >
      {{ 'pages.timeDialog.tagestotal' | translate }}
    </mat-checkbox>
      <mat-form-field [ngClass]="{'hidden': !timeForm.controls['tagestotal'].value}" class="dauerFeld" appearance="outline" color="accent">
        <mat-label>{{ 'pages.timeDialog.tagesist' | translate }}</mat-label>
        <input
          (ngModelChange)="calculateRest()"
          [ngModel]="($istZeit | async) | number:'1.2-2' : 'en'"
          [decimalNumbersOnlyMax]=10000
          [kommaStellen]=2
          matInput
          [placeholder]="'pages.timeDialog.tagesist' | translate"
          formControlName="tagesist"
        />
        <!--<mat-error *ngIf="timeForm.controls['dauerExtern'].invalid">{{ getErrorMessage('dauerExtern') | translate }}</mat-error>-->
      </mat-form-field>

      <mat-form-field [ngClass]="{'hidden': !timeForm.controls['tagestotal'].value}" class="dauerFeld" appearance="outline" color="accent">
        <mat-label>{{ 'pages.timeDialog.tagessoll' | translate }}</mat-label>
        <input
          (ngModelChange)="calculateRest()"
          [ngModel]="($sollZeit | async) | number:'1.2-2' : 'en'"
          [decimalNumbersOnlyMax]=10000
          [kommaStellen]=2
          matInput
          [placeholder]="'pages.timeDialog.tagessoll' | translate"
          formControlName="tagessoll"
        />
        <!--<mat-error *ngIf="timeForm.controls['dauerExtern'].invalid">{{ getErrorMessage('dauerExtern') | translate }}</mat-error>-->
      </mat-form-field>
      <mat-form-field [ngClass]="{'hidden': !timeForm.controls['tagestotal'].value}" class="dauerFeld noPaddingRight" appearance="outline" color="accent">
        <mat-label>{{ 'pages.timeDialog.tagesrest' | translate }}</mat-label>
        <input
          [decimalNumbersOnlyMax]=10000
          [kommaStellen]=2
          matInput
          [placeholder]="'pages.timeDialog.tagesrest' | translate"
          formControlName="tagesrest"
        />
        <!--<mat-error *ngIf="timeForm.controls['dauerExtern'].invalid">{{ getErrorMessage('dauerExtern') | translate }}</mat-error>-->
      </mat-form-field>

      <button (click)="zeitVerteilen(timeForm.controls.tagesrest.value);" [ngClass]="{'hidden': !timeForm.controls['tagestotal'].value}" class="outLineNone" mat-icon-button>
        <mat-icon>more_time</mat-icon>
      </button>
    </div>

    <mat-form-field  appearance="outline" color="accent">
      <mat-label>{{ 'pages.timeDialog.cache' | translate }}</mat-label>
      <mat-select  (ngModelChange)="selectProjects($event)" formControlName="cache">
        <mat-option *ngFor="let cacheNode of ($cache | async)" [value]="cacheNode.id">
          {{cacheNode.obersteProjektstufe.join(' - ')}}
        </mat-option>
      </mat-select>
    </mat-form-field>


    <div class="rowTimeForm">

      <mat-form-field class="datumFeld" appearance="outline" color="accent">
        <mat-label>{{ 'pages.timeDialog.datum' | translate }}</mat-label>
        <input
          (ngModelChange)="calculateDayIsTime($event)"
          matInput
          [placeholder]="'pages.timeDialog.datum' | translate"
          [matDatepicker]="datepicker"
          formControlName="datum"
        />
        <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
        <mat-datepicker #datepicker>
        </mat-datepicker>
      </mat-form-field>


      <mat-form-field class="dauerFeld" appearance="outline" color="accent">
        <mat-label>{{ 'pages.timeDialog.dauer.intern' | translate }}</mat-label>
        <input
          (focus)="$event.target.select()"
          (ngModelChange)="calculateTime()"
          [decimalNumbersOnlyMax]=10000
          [kommaStellen]=2
          (focusout)="dauerUebergeben(timeForm.value.dauerIntern)"
          matInput
          [placeholder]="'pages.timeDialog.dauer.intern' | translate"
          formControlName="dauerIntern"
          required
        />
        <!--<mat-error *ngIf="timeForm.controls['dauerIntern'].invalid">{{ getErrorMessage('dauerIntern') | translate }}</mat-error>-->
      </mat-form-field>

      <mat-form-field class="dauerFeld" appearance="outline" color="accent">
        <mat-label>{{ 'pages.timeDialog.dauer.extern' | translate }}</mat-label>
        <input
          (focus)="$event.target.select()"
          [decimalNumbersOnlyMax]=10000
          [kommaStellen]=2
          matInput
          [placeholder]="'pages.timeDialog.dauer.extern' | translate"
          formControlName="dauerExtern"
        />
        <!--<mat-error *ngIf="timeForm.controls['dauerExtern'].invalid">{{ getErrorMessage('dauerExtern') | translate }}</mat-error>-->
      </mat-form-field>

      <mat-form-field class="serienDatumFeld" appearance="outline" color="accent">
        <mat-label>{{ 'pages.timeDialog.serienerfassung' | translate }}</mat-label>
        <input
          matInput
          formControlName="serienDatum"
        />

          <mat-icon [matMenuTriggerFor]="appMenu" class="smallButton">calendar_today</mat-icon>
        <!--<mat-error *ngIf="timeForm.controls['dauerExtern'].invalid">{{ getErrorMessage('dauerExtern') | translate }}</mat-error>-->
      </mat-form-field>
    </div>

    <div class="rowTimeForm">


      <mat-radio-group formControlName="verrechnen">
        <mat-radio-button (change)="disableVerrechnet(false)" class="radioButton" value="1">{{ 'pages.timeDialog.verrechnen' | translate }}</mat-radio-button>
        <mat-radio-button (change)="disableVerrechnet(true)" class="radioButton" value="2">{{ 'pages.timeDialog.niverbar' | translate }}</mat-radio-button>
      </mat-radio-group>

      <mat-checkbox formControlName="verrechnet"
                    class="checkboxAbstand"
      >
        {{ 'pages.timeDialog.verrechnet' | translate }}
      </mat-checkbox>

      <mat-checkbox formControlName="ferien"
                    class="checkboxAbstand"
                    (change)="setProjektstufeDisabled($event.checked)"
      >
        {{ 'pages.timeDialog.ferien' | translate }}
      </mat-checkbox>

    </div>

    <mat-form-field class="abstandZeiterfassung" appearance="outline" color="accent" >
      <mat-label>{{ 'pages.timeDialog.text' | translate }}</mat-label>
      <input
        matInput
        (ngModelChange)="filter($event)"
        [placeholder]="'pages.timeDialog.text' | translate"
        formControlName="text"
        [matAutocomplete]="auto">

      <mat-autocomplete #auto="matAutocomplete">
        <mat-option class="optionHeight" *ngFor="let cacheOption of ($taetCache | async)" [value]="cacheOption">
          {{cacheOption}}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="timeForm.controls.text.invalid">{{ getErrorMessage('text') | translate }}</mat-error>
    </mat-form-field>

  </form>

  <div class="einruecken">
    <h2 class="untenAbstand" mat-dialog-title>{{ data.spesenTitle | translate }}
      <div class="add-button-container">
        <button matTooltip="Spesen Hinzufügen" (click)="addSpesen()" mat-mini-fab color="warn" aria-label="Add a address" class="pluscolor">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </h2>

    <ng-container *ngIf="($spesen | async).length !==0">
      <app-spesen-table
        [zeitId]="data.id"
        [spesen]="$spesen | async"
      ></app-spesen-table>
    </ng-container>
  </div>
</mat-dialog-content>

<!----------------------------------------------------------------------------------------------------------------------------->
<mat-dialog-content *ngIf="isSmallDevice" class="mat-typography">
  <form class="form-wrapper" [formGroup]="timeForm" autocomplete=off>

    <zeiterfassung-stufen class="stufenAnzeige"
                          [selectboxItems]="$projektSelectbox | async"
    >
    </zeiterfassung-stufen>

    <mat-form-field class="abstandZeiterfassung" appearance="outline" color="accent">
      <mat-label>{{ 'pages.timeDialog.cache' | translate }}</mat-label>
      <mat-select (ngModelChange)="selectProjects($event)" formControlName="cache">
        <mat-option *ngFor="let cacheNode of ($cache | async)" [value]="cacheNode.id">
          {{cacheNode.obersteProjektstufe.join(' - ')}}
        </mat-option>
      </mat-select>
    </mat-form-field>


    <div  class="rowTimeForm abstandZeiterfassung">

      <mat-form-field class="datumFeld" appearance="outline" color="accent">
        <mat-label>{{ 'pages.timeDialog.datum' | translate }}</mat-label>
        <input
          (ngModelChange)="calculateDayIsTime($event)"
          matInput
          [placeholder]="'pages.timeDialog.datum' | translate"
          [matDatepicker]="datepicker"
          formControlName="datum"
        />
        <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
        <mat-datepicker #datepicker>
        </mat-datepicker>
      </mat-form-field>
    </div>
    <div  class="rowTimeForm abstandZeiterfassung">

      <mat-form-field class="dauerFeld" appearance="outline" color="accent">
        <mat-label>{{ 'pages.timeDialog.dauer.intern' | translate }}</mat-label>
        <input
          (focus)="$event.target.select()"
          (ngModelChange)="calculateTime()"
          [decimalNumbersOnlyMax]=10000
          [kommaStellen]=2
          (focusout)="dauerUebergeben(timeForm.value.dauerIntern)"
          matInput
          [placeholder]="'pages.timeDialog.dauer.intern' | translate"
          formControlName="dauerIntern"
          required
        />
      </mat-form-field>

      <mat-form-field class="dauerFeld" appearance="outline" color="accent">
        <mat-label>{{ 'pages.timeDialog.dauer.extern' | translate }}</mat-label>
        <input
          (focus)="$event.target.select()"
          [decimalNumbersOnlyMax]=10000
          [kommaStellen]=2
          matInput
          [placeholder]="'pages.timeDialog.dauer.extern' | translate"
          formControlName="dauerExtern"
        />
      </mat-form-field>
    </div>

    <div class="rowTimeForm">


      <mat-radio-group formControlName="verrechnen">
        <mat-radio-button (change)="disableVerrechnet(false)" class="radioButton" value="1">{{ 'pages.timeDialog.verrechnen' | translate }}</mat-radio-button>
        <mat-radio-button (change)="disableVerrechnet(true)" class="radioButton" value="2">{{ 'pages.timeDialog.niverbar' | translate }}</mat-radio-button>
      </mat-radio-group>
      <button *ngIf="isSmallDevice" (click)="zeitVerteilen(timeForm.controls.tagesrest.value);" class="outLineNone" mat-icon-button>
        <mat-icon>more_time</mat-icon>
      </button>
    </div>


    <mat-form-field class="example-full-width" appearance="fill">
      <mat-label>Number</mat-label>
      <input type="text"
             placeholder="Pick one"
             aria-label="Number"
             matInput
             [formControl]="myControl"
             [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
          {{option}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
<!--
    <mat-form-field class="abstandZeiterfassung" appearance="outline" color="accent" >
      <mat-label>{{ 'pages.timeDialog.text' | translate }}</mat-label>
      <input
        (ngModelChange)="filter($event)"
        matInput
        [placeholder]="'pages.timeDialog.text' | translate"
        formControlName="text"
        [matAutocomplete]="auto"
      >

      <mat-autocomplete #auto="matAutocomplete">
        <mat-option class="optionHeight" *ngFor="let option of ['eins', 'zwei', 'drei']" [value]="option">
          {{option}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
-->
  </form>

<div class="einruecken">
  <h2 mat-dialog-title>{{ data.spesenTitle | translate }}
    <div class="add-button-container">
      <button matTooltip="Spesen Hinzufügen" (click)="addSpesen()" mat-mini-fab color="warn" aria-label="Add a address" class="pluscolor">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </h2>

  <ng-container *ngIf="($spesen | async).length !==0">
    <app-spesen-table
      [zeitId]="data.id"
      [spesen]="$spesen | async"
    ></app-spesen-table>
  </ng-container>
</div>
</mat-dialog-content>




<mat-dialog-actions align="end">
  <button

    id="abbruch"
    color="none"
    (click)="handleCancelClick()"
    [tabIndex]="-1"
  >
    {{ data.cancelButtonLabel | translate }}
  </button>
  <button
    *ngIf="stufe"
    mat-raised-button
    color="accent"
    (click)="handleSubmitClick()"
    [disabled]="timeForm.invalid || (stufe.addButtonForm.invalid && !timeForm.controls['ferien'].value)"
  >
    {{ data.submitButtonLabel | translate }}
  </button>
</mat-dialog-actions>
<button hidden="true" id="updateButton" mat-button (click)="updateTagesIstWithoutTime(false)">Add Time</button>

<mat-menu #appMenu="matMenu" class="drop-calendar" >
  <div (click)="$event.stopPropagation()">
    <mat-calendar #calendar (selectedChange)="select($event,calendar)" [dateClass]="isSelected">
    </mat-calendar>


  </div>
  <button
    class="calendarPosition"
    mat-raised-button
    color="accent">

    {{ data.submitButtonLabel | translate }}
  </button>
</mat-menu>
